import React, { memo } from 'react';
import Lottie from 'lottie-react';
import AiVariant3StarIcon from './json/ai-variant-3-star-icon.json';

/**
 * AiSearchFilterAnimation Component
 *
 * This component displays an animated AI search filter indicator, including
 * a Lottie animation and a message informing the user that their lead is
 * being searched using smart AI filters. The animation loops continuously
 * until the search is completed.
 *
 * @returns React Component
 */

const AiSearchFilterAnimation: React.FC = () => (
  <div className="ai-search-animation">
    <Lottie
      animationData={AiVariant3StarIcon} // Animation data for the 3-star icon
      loop // Loops the animation continuously
      className="ai-3-star-animated-icon" // Custom CSS class for styling the animation
    />

    <span>
      Hang tight!
      <br /> Your lead is being searched using smart AI filters
    </span>
  </div>
);
export default memo(AiSearchFilterAnimation);
